import React from "react";

const CalendarSetting = () => {
  return (
    <div className="grid gap-4">
      <div className="space-y-2">
        <h4 className="font-medium leading-none">Setting</h4>
        <p className="text-sm text-muted-foreground">Attendance performance setting.</p>
      </div>
    </div>
  );
};

export default CalendarSetting;
